import React, { useEffect } from 'react';
import moment from 'moment';
import { getOptionsValues } from '@gp/utils/common';
import { MANAGEMENT_SEGMENT_KEY_ISSUES, MANAGEMENT_SEGMENT_BOARD_GOVERNANCE } from '../constants';

import type { IStudioOverallManagementOptionsData, IStudioOverallManagementFilter } from '../components/Filter';

/**
 * 初始化获取数据逻辑
 * 1、筛选器选项数据、页面数据同步获取
 * 2、筛选器选项数据返回后，setFilter，默认全选
 */
export default function useInit(props: {
  segmentId: string;
  isOptionsDataLoading: boolean;
  optionsData: IStudioOverallManagementOptionsData;
  setFilter: React.Dispatch<React.SetStateAction<IStudioOverallManagementFilter>>;
  keyIssuesRunPlus: (params: IStudioOverallManagementFilter) => void;
  boardGovernanceRunPlus: (params: IStudioOverallManagementFilter) => void;
}) {
  const { segmentId, isOptionsDataLoading, optionsData, setFilter, keyIssuesRunPlus, boardGovernanceRunPlus } = props;

  /**
   * 获取筛选器选项数据到后（接口返回数据后），setFilter
   */
  useEffect(() => {
    if (isOptionsDataLoading) return;
    const studiosIds = getOptionsValues(optionsData?.studios);
    const businessesIds = getOptionsValues(optionsData?.businesses);
    const filterTemp = {
      studio: studiosIds,
      business_owner: businessesIds,
      // 默认选中当前，后端会返回当年
      year: moment()?.format('YYYY'),
    };
    setFilter(filterTemp);
  }, [isOptionsDataLoading, optionsData]);

  /**
   * 获取页面数据
   */
  useEffect(() => {
    const filterTemp = {
      studio: [],
      business_owner: [],
      // 默认选中当前，后端会返回当年
      year: moment()?.format('YYYY'),
    };
    segmentId === MANAGEMENT_SEGMENT_KEY_ISSUES && keyIssuesRunPlus(filterTemp);
    segmentId === MANAGEMENT_SEGMENT_BOARD_GOVERNANCE && boardGovernanceRunPlus(filterTemp);
  }, [segmentId]);
}
